var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlass5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.99219 18V14C3.99219 8 7.99219 4 13.9922 4H33.9922C39.9922 4 43.9922 8 43.9922 14V18",
    stroke: "#219EBC",
    strokeWidth: 2.79808,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99219 29.999V33.999C3.99219 39.999 7.99219 43.999 13.9922 43.999H33.9922C39.9922 43.999 43.9922 39.999 43.9922 33.999V29.999",
    stroke: "#219EBC",
    strokeWidth: 2.79808,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9992 22.3832C27.4333 22.3832 30.2171 19.5993 30.2171 16.1652C30.2171 12.7311 27.4333 9.94727 23.9992 9.94727C20.5651 9.94727 17.7812 12.7311 17.7812 16.1652C17.7812 19.5993 20.5651 22.3832 23.9992 22.3832Z",
    stroke: "#219EBC",
    strokeWidth: 2.79808,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6852 34.8204C34.6852 30.0077 29.8974 26.1152 24.0027 26.1152C18.1081 26.1152 13.3203 30.0077 13.3203 34.8204",
    stroke: "#219EBC",
    strokeWidth: 2.79808,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlass5);
export default __webpack_public_path__ + "static/media/glass5.a021e1db7ecc563b3f7a0fdc28062178.svg";
export { ForwardRef as ReactComponent };